import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import { getWorkingDayType } from 'modules/contracts/lib/workingDayType'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

import Item from './Item'

interface Props {
  contractVersion: ContractVersion
  canEdit?: boolean
}

const WorkingDayType = ({ contractVersion, canEdit = false }: Props) => {
  const contractData = useLegalEntityContractData()
  if (!contractVersion.isFrench && !contractVersion.isSpanish) return null

  const workingDayType = getWorkingDayType(contractVersion, {
    franceWorkTypes: contractData.frenchContractData.workTypes.map((workType) => {
      return {
        id: workType.id,
        name: workType.name,
      }
    }),
    spainWorkTypes: contractData.spanishContractData.workingDayTypes.map((workType) => {
      return {
        id: workType.id,
        name: workType.name,
      }
    }),
  })

  if (!workingDayType && !canEdit) return null

  return (
    <Item
      id="working_day_type"
      title={i18n.t('contract_versions.time.working_day_type')}
      description={workingDayType}
    />
  )
}

export default observer(WorkingDayType)
